import Select, { components } from "react-select";

const AdminSelect = ({
  prefixIcon = null,
  options = [],
  onChange,
  value,
  defaultValue,
  placeholder = "",
  label = null,
  mb = "mb-3",
  className = ""
}) => {
  const styles = {
    control: (base, state) => ({
      ...base,
      minHeight: 50,
      borderColor: state.isFocused ? "#dbbe78" : base.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #dbbe78" : base.boxShadow,
      "&:hover": { borderColor: "#dbbe78" },
    }),
    valueContainer: (base) => ({
      ...base,
      ...(prefixIcon ? { paddingLeft: 43 } : {}),
      fontFamily: "Hanken Grotesk",
      fontSize: "15px !important",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#dbbe78"
        : state.isFocused
          ? "#f5edda"
          : "transparent",
      color: state.isSelected ? "#fff" : base.color,
      "&:active": { backgroundColor: "#c9a84c" },
      fontFamily: "Hanken Grotesk",
      fontSize: "15px !important",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: "Hanken Grotesk",
      fontSize: "15px !important",
    }),
  };

  const IconValueContainer = ({ children, ...props }) => (
    components.ValueContainer && (
      <components.ValueContainer {...props}>
        {!!children && (
          <span
            style={{
              position: "absolute",
              left: 8,
              paddingLeft: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            {prefixIcon}
          </span>
        )}
        {children}
      </components.ValueContainer>
    )
  );

  return (
    <div className={mb}>
      {label && <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">{label}</label>}
      <Select
        className={`${className}`}
        options={options}
        onChange={onChange}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        styles={styles}
        components={prefixIcon ? { ValueContainer: IconValueContainer } : undefined}
      />
    </div>
  );
};

export default AdminSelect;
